import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Footer } from "@/components/Footer";

const FILTERS = [
  { key: "", label: "All Feeders" },
  { key: "insects", label: "Insects" },
  { key: "rodents", label: "Rodents" },
];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data));
  }, []);

  const shown = category ? products.filter((p) => p.category === category) : products;

  return (
    <div className="App bg-[#080808] pt-16">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-16">
        <p className="overline mb-4">The Catalog</p>
        <h1 className="font-display font-light text-5xl md:text-7xl tracking-tighter mb-12">Choose your feeder.</h1>

        <div className="flex gap-6 border-b border-[#222] pb-4 mb-12">
          {FILTERS.map((f) => (
            <button key={f.key} data-testid={`filter-${f.key || "all"}`}
              onClick={() => (f.key ? setParams({ category: f.key }) : setParams({}))}
              className={`overline transition-colors ${category === f.key ? "text-[#C7F000]" : "text-[#8A8782] hover:text-[#F4F1EC]"}`}>
              {f.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-testid="shop-grid">
          {shown.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
        </div>
        {shown.length === 0 && <p className="text-[#8A8782] text-sm">Loading feeders…</p>}
      </div>
      <Footer />
    </div>
  );
}
